"use strict";

var React = require('react'),
    DocumentTitle = require('react-document-title'),
    ToolboxSidebar = require('./Sidebar'),
    Header = require('./Header'),
    Footer = require('./Footer'),
    Contact = require('../project/ProjectContactBuilder'),
    $ = require('jquery');

var ToolboxContact = React.createClass({displayName: "ToolboxContact",
    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            description = (
                React.createElement("p", null, 
                    "Below is the information for contacting the builder's representative. If you have" + ' ' + 
                    "technical questions, please click on the \"", React.createElement("a", {href: "#", onClick: me.toggleHelp}, "help"), "\" button on the right side to" + ' ' + 
                    "contact New Construction Hub for technical help."
                )
            ),
            title = props.title + ' - Contact';

        return (
            React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                React.createElement(Header, {project: props.project, builder: props.builder}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement(ToolboxSidebar, {project: props.project}), 
                        React.createElement("div", {className: "col-sm-9"}, 
                            React.createElement("h1", null, "Contact Builder"), 
                            React.createElement(Contact, {model: props.project, description: description})
                        ), 
                        React.createElement(Footer, {trackerId: "agent-toolbox-contact"})
                    )
                )
            )
        );
    },

    toggleHelp: function(e) {
        if(e && e.preventDefault) {
            e.preventDefault();
        }

        if(window.FreshWidget && $(FreshWidget.iframe()).is(':visible')) {
            FreshWidget.hide();
        } else if(window.FreshWidget) {
            FreshWidget.show();
            $(FreshWidget.iframe()).attr('scrolling', 'no');
        }
    }
});

module.exports = ToolboxContact;
